import { render, staticRenderFns } from "./franchise-shipping.vue?vue&type=template&id=1308cf0c&"
import script from "./franchise-shipping.vue?vue&type=script&lang=js&"
export * from "./franchise-shipping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports